var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonotonyAscending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.33 77.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#282828;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.67,.11C17.41,.11,.11,17.41,.11,38.67s17.29,38.55,38.55,38.55,38.55-17.29,38.55-38.55S59.92,.11,38.67,.11Zm0,74.58C18.8,74.7,2.63,58.54,2.63,38.67S18.8,2.63,38.67,2.63s36.03,16.16,36.03,36.03-16.16,36.03-36.03,36.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.33,36.48h-8.02v-8.02c0-.7-.56-1.26-1.26-1.26s-1.26,.56-1.26,1.26v8.02H13.78c-.7,0-1.26,.56-1.26,1.26s.56,1.26,1.26,1.26h8.02v8.02c0,.7,.56,1.26,1.26,1.26s1.26-.56,1.26-1.26v-8.02h8.02c.7,0,1.26-.56,1.26-1.26s-.56-1.26-1.26-1.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.52,17.77s-.03-.06-.06-.09c-.25-.25-.58-.37-.91-.37-.33,0-.66,.12-.91,.37-.03,.03-.04,.06-.06,.09l-6.66,6.66c-.49,.49-.49,1.29,0,1.78,.25,.25,.57,.37,.89,.37s.64-.12,.89-.37l4.57-4.57,.19,38.2c0,.69,.57,1.25,1.26,1.25h0c.7,0,1.26-.57,1.25-1.27l-.19-38.2,4.59,4.59c.25,.25,.57,.37,.89,.37s.64-.12,.89-.37c.49-.49,.49-1.29,0-1.78l-6.66-6.66Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonotonyAscending);
export default __webpack_public_path__ + "static/media/monotony_ascending.6eb298e01fe391f9cff1bb60b06adae6.svg";
export { ForwardRef as ReactComponent };